import { Container  } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

export default function Content() {

    return (
        <Container fluid>
            <Outlet />
        </Container>
    );
}